export default __webpack_public_path__ + "static/media/Estate-Cobble-I-II-Cream-Terracotta-Brown.03c3b2cc.jpg";